import gql from 'graphql-tag'
import { absenceFragment, absenceTypeFragment } from '@/graphql/absence/absenceFragments'

// export const UPSERTABSENCE = gql`
//     mutation upsertAbsence(
//         $id: ID
//         $name: String!
//         $description: String
//         $typeID: ID
//         $disconnectType: Boolean
//         $tracked: Boolean
//         $applyTo: ApplyToModels
//     ){
//         upsertAbsence(
//             input: {
//                 id: $id
//                 name: $name
//                 description: $description
//                 type: {
//                     connect: $typeID
//                     disconnect: $disconnectType
//                 }
//                 tracked: $tracked
//                 applyTo: $applyTo
//             }
//         ){
//             ...absenceFragment
//             type {
//                 ...absenceTypeFragment
//             }
//         }
//     }
//     ${absenceFragment}
//     ${absenceTypeFragment}
// `
export const UPSERTABSENCETYPE = gql`
    mutation upsertAbsenceType(
        $id: ID
        $name: String!
    ){
        upsertAbsenceType(
            id: $id
            name: $name
        ){
            ...absenceTypeFragment
        }
    }
    ${absenceTypeFragment}
`
export const RESTOREABSENCETYPE = gql`
    mutation restoreAbsenceType(
        $id: ID!
    ){
        restoreAbsenceType(
            id: $id
        ){
            ...absenceTypeFragment
        }
    }
    ${absenceTypeFragment}
`

export const DELETEABSENCE = gql`
    mutation deleteAbsence(
        $id: ID!
    ){
        deleteAbsence(
            id: $id
        ){
            ...absenceFragment
        }
    }
    ${absenceFragment}
`
export const DELETEABSENCETYPE = gql`
    mutation deleteAbsenceType(
        $id: ID!
    ){
        deleteAbsenceType(
            id: $id
        ){
            ...absenceTypeFragment
        }
    }
    ${absenceTypeFragment}
`